import type { MouseEvent, ReactNode } from 'react';
import { CardActionArea, Card as CardMui } from '@mui/material';
import { Container } from './components/container';
import { Content } from './components/content';
import { Header } from './components/header';
import { Subtitle, Title } from './components/heading';
import { MetaItem } from './components/meta';
import { Prices } from './components/prices';
import { Skeleton } from './components/skeleton';

interface CardProps {
  children: ReactNode;
  href?: string;
  onClick?: (event: MouseEvent) => void;
}

const Card = ({ children, href, onClick }: CardProps) => {
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.(event);
  };

  return (
    <CardMui
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: ({ palette }) => `1px solid ${palette.background.default}`,
      }}
    >
      {href || onClick ? (
        <CardActionArea
          onClick={href && onClick ? handleClick : onClick}
          href={href ?? ''}
          target={href ? '_blank' : undefined}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            alignItems: 'stretch',
            '&:hover': { textDecoration: 'none', color: 'inherit' },
          }}
        >
          {children}
        </CardActionArea>
      ) : (
        children
      )}
    </CardMui>
  );
};

export {
  Card as ResourceCard,
  Header as ResourceCardHeader,
  Prices as ResourceCardPrices,
  Content as ResourceCardContent,
  Container as ResourceCardContainer,
  Title as ResourceCardTitle,
  Subtitle as ResourceCardSubtitle,
  MetaItem as ResourceCardMetaItem,
  Skeleton as ResourceCardSkeleton,
};
